import { isProductionEnv } from './utils';

export const API_PREFIX = '/api/v1';

export const ERR_OK = 200;

const NO_TIME_OUT = 0;
const SHORT_TIME_OUT = isProductionEnv() ? 10000 : NO_TIME_OUT;
const LONG_TIME_OUT = isProductionEnv() ? 30000 : NO_TIME_OUT;
export { NO_TIME_OUT, SHORT_TIME_OUT, LONG_TIME_OUT };

const STATUS_LOADING = 'loading';
const STATUS_LOADED = 'loaded';
const STATUS_NO_DATA = 'noData';
const STATUS_ERROR = 'error';
export { STATUS_LOADING, STATUS_LOADED, STATUS_NO_DATA, STATUS_ERROR };

export const MdColors = [
  '#F44336',
  '#E91E63',
  '#9C27B0',
  '#673AB7',
  '#3F51B5',
  '#2196F3',
  '#03A9F4',
  '#00BCD4',
  '#009688',
  '#4CAF50',
  '#8BC34A',
  '#CDDC39',
  '#FFEB3B',
  '#FFC107',
  '#FF9800',
  '#FF5722',
  '#795548',
  '#9E9E9E',
  '#607D8B',
];
